export const togglebuttongroup = {
  alignItems: { value: 'center' },
  alignContent: { value: 'center' },
  justifyContent: { value: 'flex-start' },
};
